import React, { Component } from "react"
import { Link } from "gatsby"

class FooterCopyright extends Component {
  render() {
    return (
      <footer id="footer" className="midnight-blue">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <p>
                © 2018{" "}
                <a
                  target="_blank"
                  href="https://morosoft.org"
                  title="Morosoft Copyright"
                >
                  Morosoft
                </a>
                . All Rights Reserved.
              </p>
            </div>

            <div className="col-sm-6">
              <ul className="footer-bottom-menu">
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/hire-us">Hire</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/">Home</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default FooterCopyright
